import { render, staticRenderFns } from "./CultivationList.vue?vue&type=template&id=2ae4e17a&scoped=true&lang=html&"
import script from "./CultivationList.vue?vue&type=script&lang=js&"
export * from "./CultivationList.vue?vue&type=script&lang=js&"
import style0 from "./CultivationList.vue?vue&type=style&index=0&id=2ae4e17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae4e17a",
  null
  
)

export default component.exports